import React from "react";

const PageLoader = ({ message = "Loading..." }) => {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center px-4">
        {/* Logo */}
        <div className="mb-8">
          <img
            src="/Knots&KraftsLogo.png"
            alt="Knots & Krafts"
            className="w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 lg:w-40 lg:h-40 xl:w-48 xl:h-48 mx-auto object-contain"
          />
        </div>

        {/* Loading Message */}
        <p className="text-gray-600 text-sm mb-6">{message}</p>

        {/* Loading Bar */}
        <div className="w-48 sm:w-56 md:w-64 lg:w-72 mx-auto">
          <div className="w-full bg-gray-200 h-2 rounded-full overflow-hidden">
            <div
              className="bg-primary-600 h-2 rounded-full animate-pulse"
              style={{
                width: "60%",
                animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
              }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageLoader;
